<script setup lang="ts">
import { LucideArrowRight } from 'lucide-vue-next'
import type { IWidgetAdsBlock } from './index'

const props = defineProps<IWidgetAdsBlock>()

const isInternal = computed(() => props.type === 'internal')
const isExternal = computed(() => props.type === 'external')
</script>

<template>
  <section
    class="relative flex items-center rounded-lg border border-orange-600 bg-white p-4 hover:border-orange-500"
  >
    <article class="space-y-0.5 sm:mr-4">
      <div class="flex flex-col gap-4 md:flex-row">
        <div v-if="props.image" class="flex h-9 min-w-[100px] flex-col justify-center md:h-auto">
          <NuxtImg
            :src="useAsset(props.image)"
            :alt="props.heading"
            format="avif,webp"
            class="h-auto w-full max-w-[100px]"
            fetch-priority="high"
          />
        </div>
        <div>
          <div class="font-serif font-bold leading-4" v-html="props.heading" />
          <p class="mt-0.5 text-sm leading-3 text-gray-700" v-html="props.text" />
          <p class="mt-1 text-[10px] text-gray-500" v-html="props.subtext" />
        </div>
      </div>
    </article>
    <Button
      v-if="props.url"
      size="auto"
      class="absolute right-4 top-4 ml-auto h-9 w-9 min-w-9 rounded-full bg-orange-600 after:absolute after:inset-0 hover:bg-orange-500 md:static md:right-auto md:top-auto md:h-[52px] md:w-[52px] md:min-w-[52px]"
      as-child
    >
      <!-- Internal link -->
      <NuxtLink v-if="isInternal" :to="props.url" :aria-label="props.heading">
        <LucideArrowRight />
        <span class="sr-only">{{ props.heading }}</span>
      </NuxtLink>

      <!-- External link -->
      <a v-else-if="isExternal" :href="props.url" target="_blank" :aria-label="props.heading">
        <LucideArrowRight />
        <span class="sr-only">{{ props.heading }}</span>
      </a>
    </Button>
  </section>
</template>
